import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const madeToOrder = css`
  position: relative;
  display: flex;
  justify-content: left;
  ${fontSize(text.BODY.XS)}
  margin: 0;
  gap: ${spacing.base}px;

  [data-testid='tooltip-container'] {
    position: static;
  }
`;

export const madeToOrderLabel = css`
  ${fontSize(text.BODY.XS)}
  margin: 0;
`;

export const tooltipInfo = css`
  cursor: help;
  display: grid;
  grid-template-columns: 1fr ${spacing.md}px;
  place-items: center;
  font-size: ${pxToRem(text.BODY.XS.fontSize)};
`;

export const tooltipInfoIcon = css`
  display: block;
  height: ${spacing.md}px;
  width: ${spacing.md}px;
  margin: 0 0 0 ${spacing.base}px;
`;
